module.exports = __webpack_public_path__ + "static/img/service_banner.c63f1ad2.png";